module.exports = __webpack_public_path__ + "img/telegram.4726707e.svg";